import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PatientInsurance } from "pwapi";

import { useAppSelector } from "store/hooks";

import FlatResourceLine from "./FlatResourceLine";

type InsuranceLineProps = {
  insurance: PatientInsurance;
  onEditInsurance?: Function;
  onDeleteInsurance?: Function;
};

const InsuranceLine = ({
  insurance,
  onEditInsurance,
  onDeleteInsurance,
}: InsuranceLineProps) => {
  const handleOnDelete = () => {
    onDeleteInsurance && onDeleteInsurance(insurance);
  };

  const lab = useAppSelector(({ admin }) => admin.case?.accessioning_lab);

  const insurLocDetails =
    insurance.is_manual || lab?.use_manual_insurance
      ? {
          street: insurance.insurance_company_address,
          street2: insurance.insurance_company_address2,
          city: insurance.insurance_company_city,
          state: insurance.insurance_company_state,
          zipcode: insurance.insurance_company_zipcode,
          name: insurance.insurance_company_name,
        }
      : {
          name: insurance.plan?.payer_name,
          ...insurance.plan?.payer_location,
        };

  return (
    <FlatResourceLine
      resource={insurance}
      onEdit={onEditInsurance}
      onDelete={onDeleteInsurance && handleOnDelete}
    >
      <span>
        {insurLocDetails.name}
        <br />
        Relationship to Patient:{" "}
        {insurance.relationship_to_patient ? (
          insurance.relationship_to_patient
        ) : (
          <span style={{ color: "var(--imperialRed)" }}>
            <FontAwesomeIcon icon="exclamation-circle" /> Missing Relationship
          </span>
        )}
        <br />
        Policy Number: {insurance.policy_number}
        <br />
        Group Employer ID: {insurance.group_employer_id}
        {insurLocDetails.street && (
          <>
            <br />
            {insurLocDetails.street}
            {insurLocDetails.street2 && (
              <>
                <br />
                {insurLocDetails.street2}
              </>
            )}
            <br />
            {insurLocDetails.city}, {insurLocDetails.state}{" "}
            {insurLocDetails.zipcode}
          </>
        )}
      </span>
    </FlatResourceLine>
  );
};

export default InsuranceLine;
